
import ProductsList from "../components/Products/ProductsList"

const Headphones = () => {
    return (
        <>
        <ProductsList />
        </>
     
    )
}

export default Headphones